import {
  ChangeEmailIcon,
  ChangePasswordIcon,
  DeactiveAccountIcon,
} from "icons";
import styles from "./styles.module.scss";
import { EmailInput } from "./emailInput";
import { UseLazyApiCallOldDashboard } from "hooks/use-lazy-api-call-old-dashboard";
import { message, Spin } from "antd";

export const AccountSettings = ({ userDetails }) => {
  const settingsCardsData = [
    {
      title: "Reset Password",
      desc: "To change user's password, click the 'Send' button. User will receive an email with instructions to update the password associated with the account.",
      icon: ChangePasswordIcon,
      buttonText: "Send Reset Link",
      BtnBgColor: "#006AB3",
      key: "password",
      apiPath: "send_password_reset_email",

      emailValue: userDetails?.email,
      emailLabel: "Email Address",
    },
    {
      title: "Change Email Address",
      desc: "To change user's email address, click the 'Send' button. User will receive an email with instructions to update the email associated with the account.",
      icon: ChangeEmailIcon,
      buttonText: "Send Reset Link",
      BtnBgColor: "#006AB3",
      key: "email",
      apiPath: "send_email_change_email",

      emailValue: userDetails?.email,
      emailLabel: "Email Address",
    },
    {
      title: "Deactivate Account",
      desc: "Deactivation will temporarily disable the user’s access, hide their profile, and suspend all associated activity.",
      icon: DeactiveAccountIcon,
      buttonText: "Deactivate Account",
      BtnBgColor: "#F63E50",
      key: "deactivate",
      apiPath: "",
      emailValue: userDetails?.email,
      emailLabel: "Email Address",
    },
  ];

  return (
    <div className={styles.accountSettingsContainer}>
      {settingsCardsData.map((item) => (
        <EmailInput key={item.key} item={item} userDetails={userDetails} />
      ))}
    </div>
  );
};
